// extracted by mini-css-extract-plugin
export default {"heading":"Settings_heading__p+7p7","settings":"Settings_settings__v7p7T","button":"Settings_button__H570u","label":"Settings_label__YlDIs","group":"Settings_group__q5I7c"};